import autoBind from 'auto-bind'

export abstract class BaseComponent<T> {
  // public abstract  priority:number;

  protected app: T

  constructor(app: T) {
    this.app = app
    autoBind(this)
  }

  public abstract async init(): Promise<void>
}
